import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    createNotice,
    getNotices,
    updateNotice,
    deleteNotice
}

function createNotice(data) {
    return new Promise((resolve, reject) => {
        const request = Superagent
            .post(`${HOST_API}/notices`)
            .set('access', Storage.getItem('access'))
            .attach('file', data.file)
            .field('type', data.type)
            .field('title', data.title)
            .field('index', data.index)
            .field('display', data.display)
            .field('link', data.link || '/')
            .field('text', data.text || ' ')
            .field('expired', data.expired.toISOString())

        if (data.userId)
            request.field('userId', data.userId)

        request.end((err, res) => {
            resolve(res.body)
        })
    })
}

function getNotices(query = {}) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/notices`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateNotice(noticeId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/notices/${noticeId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteNotice(noticeId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/notices/${noticeId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}